import * as z from "zod";
import DocumentTypeEnum from "@/constants/enums/DocumentTypeEnum";

export const UploadDocumentSchema = z.object({
  document: z.string({
    required_error: "required",
    invalid_type_error: "required",
  }),
  companyIds: z.array(z.number().int()),
  fileType: z.string({}),
  languageId: z.number(),
  documentType: z.nativeEnum(DocumentTypeEnum),
  documentTitle: z.string(),
});

export type UploadDocumentFormInput = z.infer<typeof UploadDocumentSchema>;
